import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { EntityModals } from "components/shared/EntityModals/EntityModals";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import * as commonService from "utility/CommonService.js";
import * as actions from "../../../redux/actions/WorkflowActions";
import { Button } from "react-bootstrap";
import { forError, forSuccess } from "utility/CommonService.js";
import EditScheduleModal from "./EditScheduleModal";
import { getHighestAccessLevel } from "utility/utility";
import {
  ACCESS_LEVEL,
  FLIGHTING_CONSTANTS,
  routes,
} from "utility/constants/constants";
import Tooltip from '@mui/material/Tooltip';
import { EntityMenu } from "components/shared/EntityMenu/EntityMenu";
import { CalendarMonth } from "@mui/icons-material";
import { setPermissionTooltip, setPermissionOpacity } from "utility/utility";
import BreadCrumb from "components/shared/Navigation/BreadCrumb";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { updateWorkflow } from "redux/actions/WorkflowActions";
import { ENTITY_TYPES } from "utility/constants/constants";

import swal from "sweetalert";

const PauseSwitch = styled(Switch)(() => ({
  padding: 4,
  "& .MuiSwitch-track": {
    borderRadius: "20px",
    backgroundColor: "#E5E4E2",
    opacity: "1 !important",
  },
  "& .MuiSwitch-thumb": {
    color: "white",
    width: "20px",
    height: "20px",
  },
}));

export const WorkflowHeader = ({ workflow, dagInfo, projectAccessLevel, user }) => {
  const [showEditScheduleModal, setShowEditScheduleModal] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false);
  const history = useHistory();
  const workflowAccessToolTipTitle = setPermissionTooltip(ACCESS_LEVEL.EXECUTE, workflow?.access_level, "")
  const workflowAccessLevelOpacity = setPermissionOpacity(ACCESS_LEVEL.EXECUTE, workflow?.access_level)
  const projectAccessLevelOpacity = setPermissionOpacity(ACCESS_LEVEL.EDIT, projectAccessLevel)
  const [showShareModal, setShowShareModal] = useState(false);

  const dispatch = useDispatch();

  const openScheduleModal = () => {
    setShowEditScheduleModal(true);
  };

  const triggerDag = async () => {
    dispatch(
      actions.runWorkflow({
        body: {
          is_paused: dagInfo?.is_paused,
        },
        id: workflow.id,
      })
    ).then((res) => {
      if (res.value && res.value.success) {
        forSuccess("Workflow run successful!", "Success");
      } else {
        forError("Workflow run failed", "Error");
      }
    });
  };

  const handleChange = async (event, workflow) => {
    let id = workflow.id;
    dagInfo.is_paused = !event.target.checked;
    dispatch(
      actions.pauseWorkflow({
        body: {
          paused: event.target.checked ? false : true,
        },
        id,
      })
    ).then((res) => {
      if (res.value && res.value.success) {
        dispatch(actions.getWorkflows());
        commonService.forSuccess("Workflow update successful!", "Success");
      } else {
        commonService.forError("Workflow update failed", "Error");
      }
    });
  };

  const handleDeleteWorkflow = () => {
    swal({
      text: `Are you sure you want to remove this from the workflows page?`,
      className: "logout-alert-modal",
      buttons: {
        cancel: true,
        confirm: {
          text: "Delete",
          value: "delete",
        },
      },
    }).then((result) => {
      if (result === "delete") {
        dispatch(actions.deleteWorkflow(workflow.id)).then((res) => {
          if (res.value && res.value.success) {
            commonService.forSuccess("Workflow deleted successfully!", "Success");
            dispatch(actions.removeWorkflow(workflow.id));
            if (history.state !== "/workflows") {
              history.push("/workflows");
            }
          } else {
            commonService.forError("Workflow delete failed", "Error");
          }
        });
      }
    });
  };

  return (
    <div className="container">
      <div className="workflow_details_header">
        <div className="top_row">
          <div className="workflow_breadcrumb">
            <BreadCrumb
              currentLoc={workflow && workflow.name}
              previousLoc={FLIGHTING_CONSTANTS.WORKFLOWS}
              goBack={() => history.push(routes.WORKFLOWS)}
            />
          </div>
          <div className="top_row_right">
            <EntityMenu
              onEdit={() => setShowEditModal(true)}
              onShare={() => setShowShareModal(true)}
              onDelete={handleDeleteWorkflow}
              tooltipTitle="More"
            />
            {workflow && <Tooltip
              title={
                workflowAccessToolTipTitle
              }
              placement="top"
            >
              <span>
                <Button
                  className="btn_small"
                  onClick={() => triggerDag()}
                  style={{
                    opacity:workflowAccessLevelOpacity,
                  }}
                  disabled={workflow?.access_level === ACCESS_LEVEL.VIEW}
                >
                  <div className="trigger_dag">
                    <div className="circle_style">
                      <div className="arrow_style"></div>
                    </div>
                    Trigger Dag
                  </div>
                </Button>
              </span>
            </Tooltip>}
            {workflow && <Tooltip
              title={
                workflowAccessLevelOpacity === .5 && projectAccessLevelOpacity === .5
                ?"You need execute or edit workflow access and edit project access"
                :workflowAccessLevelOpacity === .5? "You need execute or edit workflow access"
                :projectAccessLevelOpacity === .5? "You need edit project access"
                :""
              }
              placement="top"
            >
              <span>
                <Button
                  onClick={() => openScheduleModal()}
                  className="btn_small"
                  style={{
                    opacity:Math.min(workflowAccessLevelOpacity, projectAccessLevelOpacity),
                  }}
                  disabled={Math.min(workflowAccessLevelOpacity, projectAccessLevelOpacity) === .5}
                >
                  <div className="organize_btn">
                    <CalendarMonth height="25px"></CalendarMonth>
                    Schedule
                  </div>
                </Button>
              </span>
            </Tooltip>}
          </div>
        </div>
        <div
          className="active-toggle"
          style={{
            paddingLeft: "40px",
            opacity: workflowAccessLevelOpacity,
          }}
        >
          <Tooltip
            title={
              workflowAccessToolTipTitle
            }
            placement="top"
          >
            <div className="active-tooltip">
              <h5 className="active-text">Active</h5>
              <PauseSwitch
                color="success"
                checked={!dagInfo?.is_paused}
                onChange={(e) => {
                  handleChange(e, workflow);
                }}
                name="workflowRunState"
                disabled={workflow?.access_level === ACCESS_LEVEL.VIEW}
              />
            </div>
            </Tooltip>
        </div>
      </div>
      <EditScheduleModal
        show={showEditScheduleModal}
        setShowEditScheduleModal={setShowEditScheduleModal}
        id={workflow?.id}
        projectId={workflow?.project_id}
        accessLevel={
          workflow ? getHighestAccessLevel(workflow, user) : ACCESS_LEVEL.VIEW
        }
        projectAccessLevel={projectAccessLevel}
      />
      <EntityModals
        entity={workflow}
        entityType={ENTITY_TYPES.WORKFLOW}
        updateEntity={updateWorkflow}
        showEditModal={showEditModal}
        setShowEditModal={setShowEditModal}
        showShareModal={showShareModal}
        setShowShareModal={setShowShareModal}
      />
    </div>
  );
};
